import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

interface AppSetting {
  id: number;
  key: string;
  value: string;
  type: string;
  description?: string;
  isPublic: boolean;
  createdAt: string;
  updatedAt: string;
}

export function useAppSettings() {
  const { data: settings, isLoading } = useQuery<AppSetting[]>({
    queryKey: ["/api/settings/public"],
    queryFn: async () => {
      const response = await apiRequest("GET", "/api/settings/public");
      return response.json();
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  const getSetting = (key: string, defaultValue?: any) => {
    const setting = settings?.find(s => s.key === key);
    if (!setting) return defaultValue;
    
    // Parse value based on type
    switch (setting.type) {
      case "boolean":
        return setting.value === "true";
      case "number":
        return Number(setting.value);
      case "json":
        try {
          return JSON.parse(setting.value);
        } catch {
          return defaultValue;
        }
      default:
        return setting.value;
    }
  };

  const appName = getSetting("app_name", "Passione Italiana");
  const appLogo = getSetting("app_logo", "");
  const appTheme = getSetting("app_theme", "dark");
  const registrationEnabled = getSetting("registration_enabled", true);
  const maintenanceMode = getSetting("maintenance_mode", false);
  const storiesEnabled = getSetting("stories_enabled", true);
  


  return {
    settings,
    isLoading,
    getSetting,
    appName,
    appLogo,
    appTheme,
    registrationEnabled,
    maintenanceMode,
    storiesEnabled,
  };
}